import { CloudDownloadOutlined, CloudUploadOutlined, DeleteOutlined, HomeOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, InputNumber, Modal, Select, Table, TableColumnsType, Typography, Switch } from "antd";
import { SortOrder } from "antd/lib/table/interface";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createSummaryStaffAPI, GetAllByServiceId } from "../../API/StaffsAPI";
import { GetAllwithMacroStepsAPI, GetAllwithMacroStepsByProjectAPI, GetByStaffwithMacroStepsAPI, UpdateHoursAPI, UploadTimeEntryAPI, DeleteTimeEntriesMassiveAPI } from "../../API/TimeEntryAPI";
import { UploadModal } from "../../components/Shared/UploadModal";
import { PeriodEnum } from "../../Enums/StaffEnum";
import { useCompany } from "../../hooks/useCompany";
import useLoading from "../../hooks/useLoading";
import useModal from "../../hooks/useModal";
import { IResponseProps } from "../../interfaces/IResponseProps";
import { StaffModel } from "../../models/staffsModel";
import { api } from "../../services/axios";
import { SetFileName } from "../../utils/SetFileName";
import './styles.css';
import { ModalDeleteMassivePointHours } from "../../components/PointHours/ModalDeleteMassivePointHours";


interface SelectsProjects {
    value: string,
    label: string,
}
interface HoursMacroSteps {
    macroStepName: string,
    hours: number,
    idMacroStep: string,
    idStaff: string,
}


interface StaffsMacroSteps {
    idStaff: string | undefined,
    period: number | undefined,
    registrationName: string | undefined,
    macroSteps: HoursMacroSteps[] | null,
}

export default function PointHours() {
    const { company } = useCompany();
    const { toggleLoading, loading } = useLoading();
    const [take, setTake] = useState(7);
    const [currentPage, setCurrentPage] = useState(1);
    const changeStaffMacro = useRef(false);
    const [totalStaffs, setTotalStaffs] = useState<number>(0);
    const [totalHours, setTotalHours] = useState<number>(0);
    const [staffs, setStaffs] = useState<StaffModel[]>([]);
    const [selectProjects, setSelectProjects] = useState<SelectsProjects[]>([]);
    const [projectNameSelected, setProjectNameSelected] = useState<string[]>();
    const [downloadType, setDownloadType] = useState<string>("Modelo");
    const [staffMacroSteps, setStaffMacroSteps] = useState<StaffsMacroSteps[]>([]);
    const { Search } = Input;
    const [form] = Form.useForm();
    const { Text } = Typography;
    const [isModalCreateOpen, setIsModaCreateOpen] = useState<boolean>(false);
    const { isShowing: isShowingExcelModal, toggle: toggleExcelModal } = useModal();
    const [fileTimeEntry, setFileTimeEntry] = useState<Blob>();
    const navigate = useNavigate();
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isMassiveModalOpen, setIsMassiveModalOpen] = useState<boolean>(false);
    const [hideZeroRows, setHideZeroRows] = useState<boolean>(false);




    async function toogledownloadTimeEntry() {
        try {
            toggleLoading(true);
            await api.get(`TimeEntry/DownloadTimeEntrys/${company.serviceId}/${company.companyId}/${downloadType}`, { responseType: 'blob' }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', SetFileName(company.title, company.year.toString(), "ApontamentoDeHoras", "xlsx"));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        } catch (error: any) {
            throw new Error(error.response.data);
        } finally {
            toggleLoading(false);
        }
    }
    async function handleUploadTimeEntry() {
        try {
            toggleLoading(true);
            toggleExcelModal();

            const formData = new FormData();

            if (fileTimeEntry != undefined) {
                formData.append('file', fileTimeEntry);
            }
            formData.append('serviceId', company.serviceId);

            await UploadTimeEntryAPI(formData).then(async (resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Upload realizado com sucesso !")
                }
            });
        } catch (err: any) {
            toast.error(err);
            toggleLoading(false);
        } finally {
            toggleLoading(false);
             await getAllStaffs();
            await getAllMacroSteps();
        }
    }

    const handleHoursChange = async (idStaff: string, macroStepId: string, value: number) => {
        try {
            toggleLoading(true);
            const UpdateHours = {
                IdMacroStep: macroStepId,
                IdStaff: idStaff,
                ServiceId: company.serviceId,
                Hours: value,
            };

            var result = await UpdateHoursAPI(UpdateHours)
            if (result.statusCode == 200) {
                navigate(0);
                toast.success("Atualização Realizada com sucesso!")
            }
        } catch (error: any) {
            throw new Error(error.response.data);
        } finally {
            toggleLoading(false);
        }
    };


    async function getAllStaffs() {
        try {
            toggleLoading(true);
            var result = await GetAllByServiceId(company.serviceId);
            var response = result.data.staffList;
            if (response) {
                var staffs: StaffsMacroSteps[] = [];
                setTotalStaffs(response.length ?? 0);
                if (Array.isArray(response)) {
                    response.forEach((item: StaffModel) => {
                        let nameRegistration = (item.registration ?? "Sem Matrícula") + " - " + item.name;
                        staffs.push({ idStaff: item.id, period: item.period, registrationName: nameRegistration, macroSteps: null });
                    });

                } else {
                    let nameRegistration = (response.registration ?? "Sem Matrícula") + " - " + response.name;
                    staffs.push({ idStaff: response.id, period: response.period, registrationName: nameRegistration, macroSteps: null })
                }
                setStaffMacroSteps(staffs)
            }
        } catch (error: any) {
            throw new Error(error.response.data);
        } finally {
            toggleLoading(false);
        }
    }


    async function getAllMacroSteps() {
        toggleLoading(true);
        try {
            const serviceId = company.serviceId;
            const response = await GetAllwithMacroStepsAPI(serviceId);
            if (Array.isArray(response.timeEntryMacroStep)) {
                setSelectProjects(response.selects)
                const staffMacroStepVO: StaffsMacroSteps[] = [];
                if (Array.isArray(staffMacroSteps)) {
                    staffMacroSteps.forEach((item: StaffsMacroSteps) => {
                     
                        staffMacroStepVO.push({
                            idStaff: item.idStaff,
                            period: item.period,
                            registrationName: item.registrationName,
                            macroSteps: response.timeEntryMacroStep.filter((hoursModel: { idStaff: string | undefined; }) => item.idStaff === hoursModel.idStaff),
                        });
                        console.log(response.timeEntryMacroStep.filter((hoursModel: { idStaff: string | undefined; }) => item.idStaff === hoursModel.idStaff));
                    });
                } else {
                    staffMacroStepVO.push({
                        idStaff: undefined,
                        period: undefined,
                        registrationName: undefined,
                        macroSteps: response.timeEntryMacroStep
                    });
                }
                let totalHours = 0;
                response.timeEntryMacroStep.forEach((item: HoursMacroSteps) => {
                    totalHours += item.hours;
                });

                setTotalHours(totalHours);
                console.log(staffMacroStepVO);
                setStaffMacroSteps(staffMacroStepVO);
                changeStaffMacro.current = true;
            }
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }


    async function createSummaryStaff(data: any) {
        toggleLoading(true);
        try {
            
            var serviceId = company.serviceId;
            const StaffSumary = {
                Period: Number(data.period),
                StaffName: data.name,
                StaffResgistration: data.registration ?? null,
                ServiceId: serviceId,
            };
            var response = await createSummaryStaffAPI(StaffSumary);
            if (response.statusCode === 200) {
                toast.success("Cadastro de funcionário resumido realizado com sucesso !!")
                getAllStaffs();
                handleCancel();
            }

        } catch (error: any) {
            toast.error(error)
        } finally {
            toggleLoading(false)
        }

    }
    async function getStaffByName(staffName: string) {
        try {
           
            toggleLoading(true);
            if (staffName != undefined && staffName != "") {
                var result = await GetByStaffwithMacroStepsAPI(company.serviceId, staffName);
                var response = result.data.staffList;
                if (response) {
                    var staffs: StaffsMacroSteps[] = [];
                    setTotalStaffs(response.length ?? 0);
                    if (Array.isArray(response)) {
                        response.forEach((itemStaff: StaffModel) => {
                            let nameRegistration = (itemStaff.registration ?? "Sem Matrícula") + " - " + itemStaff.name;
                            var staffMacro = staffMacroSteps ? staffMacroSteps.filter((StaffsMacroSteps: StaffsMacroSteps) => StaffsMacroSteps.idStaff === itemStaff.id) : null;
                            var macroSteps = staffMacro?.map(x => x.macroSteps);

                            const macroStepsFlat: HoursMacroSteps[] | null = macroSteps
                                ? macroSteps.flat().filter((step): step is HoursMacroSteps => step !== null)
                                : null;

                            staffs.push({
                                idStaff: itemStaff.id, period: itemStaff.period, registrationName: nameRegistration, macroSteps: macroStepsFlat
                            })

                        })
                        setStaffMacroSteps(staffs)
                    }
                    changeStaffMacro.current = true;

                }
            }
        } catch (error: any) {
            throw new Error(error.response.data);
        } finally {
            toggleLoading(false);
        }
    }

    async function getMacroStepsByProject() {
        try {
            
            toggleLoading(true);
            let projectNameSelecteds: string[] = [];
            if (projectNameSelected != undefined) {
                projectNameSelected.forEach((item: string) => {
                    projectNameSelecteds.push(item);
                });

                const payload = {
                    ProjectNamesSelecteds: projectNameSelecteds,
                    serviceId: company.serviceId,
                };

                var response = await GetAllwithMacroStepsByProjectAPI(payload);
                if (Array.isArray(response.timeEntryMacroStep)) {
                    const staffMacroStepVO: StaffsMacroSteps[] = [];
                    if (Array.isArray(staffMacroSteps)) {
                        staffMacroSteps.forEach((item: StaffsMacroSteps) => {
                            
                            staffMacroStepVO.push({
                                idStaff: item.idStaff,
                                period: item.period,
                                registrationName: item.registrationName,
                                macroSteps: response.timeEntryMacroStep.filter((hoursModel: { idStaff: string | undefined; }) => item.idStaff === hoursModel.idStaff),
                            });
                        });
                    } else {
                        staffMacroStepVO.push({
                            idStaff: undefined,
                            period: undefined,
                            registrationName: undefined,
                            macroSteps: response.timeEntryMacroStep
                        });
                    }
                    let totalHours = 0;
                    response.timeEntryMacroStep.forEach((item: HoursMacroSteps) => {
                        totalHours += item.hours;
                    });

                    setTotalHours(totalHours);
                    setStaffMacroSteps(staffMacroStepVO);
                    changeStaffMacro.current = true;
                }
            }
        } catch (error: any) {
            throw new Error(error.response.data);
        } finally {
            toggleLoading(false);
        }
    }
    const handleCancel = () => {
        setIsModaCreateOpen(false);
        form.resetFields();
    };


    const filtersPeriod: { text: string; value: number; }[] = [];
    const filtersRegistrationName: { text: string; value: string; }[] = [];
    staffMacroSteps.forEach(item => {
        if (!filtersPeriod.some(filter => filter.value === item.period)) {
            filtersPeriod.push({
                text: PeriodEnum[item.period ?? 6] || 'Desconhecido',
                value: item.period ?? 6,
            });
        }
        if (!filtersRegistrationName.some(filter => filter.value === item.registrationName)) {
            filtersRegistrationName.push({
                text: item.registrationName ?? "",
                value: item.registrationName ?? "",
            });
        }

    });

    const baseColumns: TableColumnsType<StaffsMacroSteps> = [
        {
            title: 'Período',
            width: 155,
            dataIndex: 'period',
            key: 'period',
            fixed: 'left',
            className: 'column-fixed',
            filters: filtersPeriod,
            sorter: (a, b) => (a.period ?? 0) - (b.period ?? 0),
            sortDirections: ['ascend', 'descend'],
            render: (value: number) => (
                <div className="d-flex align-items-center justify-content-start">
                    <p className="text-align-start my-2">
                        {PeriodEnum[value] || 'Desconhecido'}
                    </p>
                </div>
            ),
        },
        {
            title: 'Matricula - Funcionário',
            width: 500,
            dataIndex: 'registrationName',
            key: 'registrationName',
            fixed: 'left',
            className: 'column-fixed border-right-blue',
            filters: filtersRegistrationName,
            onFilter: (value, record) => record.registrationName!.includes(value as string),
            sorter: (a, b) => a.registrationName!.localeCompare(b.registrationName ?? ""),
            sortDirections: ['ascend', 'descend'],
        },
    ];



    const seen = new Set<string>();


    const uniqueMacroSteps = staffMacroSteps
        .flatMap((step) => step.macroSteps || [])
        .reduce<Record<string, HoursMacroSteps>>((acc, macroStep) => {
            acc[macroStep.idMacroStep] = macroStep;
            return acc;
        }, {});

    const dynamicMacroStepColumns = Object.values(uniqueMacroSteps).map((macroStep) => ({
        title: macroStep.macroStepName,
        key: macroStep.idMacroStep,
        dataIndex: macroStep.idMacroStep,
        className: 'editable-cell',
        width: 250,


        sorter: (a: StaffsMacroSteps, b: StaffsMacroSteps) => {
            const aStep = a.macroSteps?.find(ms => ms.idMacroStep === macroStep.idMacroStep);
            const bStep = b.macroSteps?.find(ms => ms.idMacroStep === macroStep.idMacroStep);
            return (aStep?.hours ?? 0) - (bStep?.hours ?? 0);
        },
        sortDirections: ['ascend', 'descend'] as SortOrder[],

        render: (_: any, record: StaffsMacroSteps) => {
            const found = record.macroSteps?.find((m) => m.idMacroStep == macroStep.idMacroStep
            );

            return (

                <InputNumber
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        padding: 0,
                        margin: 0,
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        overflowX: 'hidden',
                    }}
                    value={found?.hours ?? 0}
                    step={0.1}
                    min={0}
                    onBlur={(e) => {
                        const value = Number(e.target.value);
                        handleHoursChange(record.idStaff!, macroStep.idMacroStep, value ?? 0);
                    }}
                />
            )
        },
    }));



    const columns = [...baseColumns, ...dynamicMacroStepColumns];

    const visibleStaffMacroSteps = hideZeroRows
        ? staffMacroSteps.filter((s) => Array.isArray(s.macroSteps) && s.macroSteps.some(ms => (ms.hours ?? 0) > 0))
        : staffMacroSteps;



    const handleShowSizeChange = (current: any, size: any) => {
        setTake(size);
        setCurrentPage(current);
    };

    useEffect(() => {
        getAllStaffs();
    }, []);
    useEffect(() => {
        if (changeStaffMacro.current) {
            changeStaffMacro.current = false;
        } else {
            getAllMacroSteps();
        }
    }, [staffMacroSteps]);

    useEffect(() => {
        getMacroStepsByProject();
    }, [projectNameSelected])

    return (
        <>
            <div className='card '>
                <div className='breadCrumb header-card-path' >
                    <Link to={`/${company.serviceId}/home`} className='d-flex align-center header-path'>
                        <HomeOutlined className='breadCrumb-item-actual header-path-icon-home' />
                    </Link>
                    <span className='breadCrumb-separator header-path'>
                        <Link to={`/${company.serviceId}/home`} className='header-path '>
                            Homepage
                        </Link>
                    </span>
                    <span className='header-path breadCrumb-separator'>{' / '}
                    </span>
                    <span className='header-path-actual breadCrumb-separator'>
                        Horas
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center my-4">
                    <div className="d-flex align-items-center justify-content-between ms-4">
                        <div className="div-show-data">
                            <span className="span-label">Colaboradores Cadastrados:  <span className="ms-3 span-label-bold">{totalStaffs}</span></span>
                        </div>

                        <div className="div-show-data">
                            <span className="span-label">Horas inseridas:  <span className="ms-3 span-label-bold">{totalHours}</span></span>
                        </div>

                    </div>

                    <div>
                        <div>
                            <Select
                                size="large"
                                className="select-custom"
                                optionFilterProp="label"
                                filterSort={(optionA, optionB) =>
                                    (optionB?.label ?? '').toLowerCase().localeCompare((optionA?.label ?? '').toLowerCase())
                                }
                                defaultValue={[{ value: '1', label: 'Modelo' }]}
                                options={[
                                    {
                                        value: '1',
                                        label: 'Modelo',
                                    },
                                    {
                                        value: '2',
                                        label: 'Consolidado',
                                    },
                                ]}
                                onSelect={(value, option) => setDownloadType(option.label)}

                            />
                            <Button icon={<CloudDownloadOutlined />} size="large" className='ms-0 me-2 buttons-download' onClick={toogledownloadTimeEntry}>Download Modelo</Button>
                            <Button icon={<CloudUploadOutlined />} size="large" className='me-4 buttons' onClick={() => { toggleExcelModal(); }}>Upload Modelo</Button>
                        </div>

                    </div>
                </div>

                <div className="d-flex justify-content-start align-items-center my-2">
                    <div className="mx-4">
                        <Select
                            size="large"
                            placeholder="Selecione os Projetos"
                            className="select-projects"
                            optionFilterProp="label"
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={selectProjects}
                            onChange={(value) => setProjectNameSelected(value)}
                            style={{ tableLayout: 'fixed' }}
                            mode="multiple"
                        />
                    </div>

                </div>

                <div className="d-flex justify-content-between align-items-center my-3 ms-4">

                    <div style={{ width: "80%" }}>
                        <Search size="large" placeholder="Pesquisar por funcionário ..." className="select-staffs w-100" onSearch={(value) => getStaffByName(value)} allowClear />
                    </div>

                    <div className="d-flex justify-contet-between me-1 align-items-center">
                        <div className="d-flex align-items-center me-3">
                            <Switch checked={hideZeroRows} onChange={(checked) => setHideZeroRows(checked)} className="me-2" />
                            <span>Ocultar zerados</span>
                        </div>
                        <Button 
                            onClick={() => setIsMassiveModalOpen(true)}
                            disabled={selectedRowKeys.length === 0}
                            danger
                            size="large"
                            className="btn-delete-massive-danger"
                            icon={<DeleteOutlined />}
                        >
                            Deletar Massivo
                        </Button>
                        <Button icon={<PlusOutlined />} size="large" className='mx-2 button-blue' onClick={() => setIsModaCreateOpen(true)}>Criar Funcionario</Button>
                    </div>
                </div>
                <div style={{ overflowX: "auto" }} className="mx-4">
                    <Table
                        loading={loading}
                        rowKey={(record) => `${record.idStaff}`}
                        rowSelection={{ selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                        pagination={{
                            total: totalStaffs,
                            showSizeChanger: true,
                            showTotal: (total) => <Text>Total {total} items</Text>,
                            pageSize: take,
                            current: currentPage,
                            onShowSizeChange: (page, size) => handleShowSizeChange(page, size),
                            onChange: (page, size) => {
                                handleShowSizeChange(page, size);
                            },
                        }}
                        className="custom-table"
                        columns={columns}
                        dataSource={visibleStaffMacroSteps}
                        scroll={{ x: 'max-content' }}

                    />
                </div>
                <Modal
                    title="Criar Funcionário"
                    closable={{ 'aria-label': 'Custom Close Button' }}
                    open={isModalCreateOpen}
                    onCancel={handleCancel}
                    className="pb-0"
                    footer={
                        <div style={{ padding: 0, margin: 0 }}> </div>
                    }

                >
                    <Form form={form} onFinish={createSummaryStaff}>

                        <label className='d-block my-2' style={{ fontSize: '16px' }}> Selecione o período: <b style={{ color: "red" }}>*</b> </label>
                        <Form.Item
                            name="period"
                            className="my-2"
                            rules={[{ required: true, message: 'Por favor, selecione um Periodo!' }]}
                        >
                            <Select
                                size="large"
                                placeholder="Selecione o período"
                                optionFilterProp="label"
                                options={
                                    (company.counting === 0
                                        ? [
                                            { value: '0', label: 'Anual' },
                                        ]
                                        : [
                                            { value: '1', label: 'Primeiro Trimestre' },
                                            { value: '2', label: 'Segundo Trimestre' },
                                            { value: '3', label: 'Terceiro Trimestre' },
                                            { value: '4', label: 'Quarto Trimestre' },
                                        ]
                                    ).sort((a, b) => Number(a.value) - Number(b.value))
                                }

                            />
                        </Form.Item>

                        <label className='d-block my-2' style={{ fontSize: '16px' }}> Nome Completo: <b style={{ color: "red" }}>*</b> </label>
                        <Form.Item
                            name="name"
                            className="my-2"
                            rules={[{ required: true, message: 'Por favor, insira seu nome!' }]}>


                            <Input size="large" placeholder="Insira o nome do funcionário" />
                        </Form.Item>

                        <label className='d-block my-2' style={{ fontSize: '16px' }}> Matrícula:  </label>
                        <Form.Item
                            name="registration"
                            className="my-2">

                            <Input size="large" placeholder="Número da matrícula" />
                        </Form.Item>

                        <Form.Item className="mb-0">
                            <div className="d-flex justify-content-between mt-3">
                                <Button onClick={() => setIsModaCreateOpen(false)} className="w-50 me-1" size="large">
                                    Cancelar
                                </Button>
                                <Button htmlType="submit" className="w-50 ms-1 button-blue" size="large">
                                    Cadastrar
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Modal>
                {isShowingExcelModal &&
                    <UploadModal
                        action={handleUploadTimeEntry}
                        isShowing={isShowingExcelModal}
                        toggle={toggleExcelModal}
                        setFile={setFileTimeEntry}
                    />
                }

                <ModalDeleteMassivePointHours
                    isOpen={isMassiveModalOpen}
                    setOpen={setIsMassiveModalOpen}
                    operation={async () => {
                        try {
                            toggleLoading(true);
                            await DeleteTimeEntriesMassiveAPI(company.serviceId, selectedRowKeys.map(id => id.toString()));
                            toast.success("Horas dos funcionários zeradas com sucesso!");
                            setSelectedRowKeys([]);
                            await getAllStaffs();
                        } catch (error: any) {
                            toast.error("Ocorreu um erro ao tentar deletar os funcionários selecionados.");
                        } finally {
                            toggleLoading(false);
                        }
                    }}
                    itemsCount={selectedRowKeys.length}
                />


            </div >
        </>
    )


}